import { Injectable } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth'
import { AngularFireDatabase } from 'angularfire2/database'
import * as firebase from 'firebase/app'
import 'firebase/storage'

import { AngularFirestore } from 'angularfire2/firestore';
//import { AngularFire, FirebaseListObservable, AngularFireDatabase } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Rx';
import { Upload } from '../shared/upload';

@Injectable()
export class UploadService {
    constructor(private af: AngularFirestore, private db: AngularFireDatabase) {
        //this.uploadURL = "";
    }
    private basePath: string = '/uploads';
    uploads: Observable<Upload[]>;

    pushUpload(upload: Upload) {
        let storageRef = firebase.storage().ref();
        let filename = Math.random().toString(36).split('').filter(function (value, index, self) {
            return self.indexOf(value) === index;
        }).join('').substr(2, 12);
        let uploadTask = storageRef.child(this.basePath + "/" + filename + upload.file.name).put(upload.file);//storageRef.child(`${this.basePath}/${upload.file.name}`).put(upload.file);
        uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
            (snapshot) => {
                // upload in progress
                upload.progress = (uploadTask.snapshot.bytesTransferred / uploadTask.snapshot.totalBytes) * 100//(snapshot.bytesTransferred / snapshot.totalBytes) * 100
            },
            (error) => {
                // upload failed
                console.log(error)
            },
            () => {
                // upload success
                upload.url = uploadTask.snapshot.downloadURL
                upload.name = upload.file.name
                this.saveFileData(upload);
            }
        );
    }
    // Writes the file details to the realtime db
    saveFileData(upload: Upload) {
        //this.db.list(`${this.basePath}/`).push(upload);
        this.db.list(this.basePath + "/").push(upload);
    }

    deleteUpload(upload: Upload) {
        this.deleteFileData(upload.$key)
            .then(() => {
                this.deleteFileStorage(upload.name)
            })
            .catch(error => console.log(error))
    }
    // Deletes the file details from the realtime db
    private deleteFileData(key: string) {
        return this.db.list(this.basePath + "/").remove(key);
    }
    // Firebase files must have unique names in their respective storage dir
    // So the name serves as a unique key
    private deleteFileStorage(name: string) {
        let storageRef = firebase.storage().ref();
        storageRef.child(`${this.basePath}/${name}`).delete()
    }
}


// WEBPACK FOOTER //
// ./src/app/uploads/shared/upload.service.ts